import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-ramadan20-brawl-stars',
  templateUrl: './ramadan20-brawl-stars.component.html',
  styleUrls: ['./ramadan20-brawl-stars.component.css']
})
export class Ramadan20BrawlStarsComponent implements OnInit {

  gameName = "brawl-stars";
  constructor(private titleService:Title) {
    this.titleService.setTitle('Brawl Stars MENA Community Cup')
  }

  ngOnInit() {
  }

}
